module.exports = __webpack_public_path__ + "static/classhook-original-homepage-e635e1eb66cfe1930723bae5059f7b2e.jpg";